import React, {createContext, useContext, useState, useEffect} from 'react';
import {callAction} from '../utils/api';

import {storeAuthData, retrieveAuthData, clearAuthData} from '../utils/auth'


const AuthContext = createContext(null);

export function AuthProvider({children, accessToken, email , ...props}) {
    const [customerData, setCustomerData] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isValidating, setIsValidating] = useState(true);
    const [commerceClient, setCommerceClient] = useState(null);
    const [autoAuth, setAutoAuth] = useState(false);

    // console.log('customerData in AuthProvider:', customerData);

    useEffect(() => {
    const validateToken = async () => {
        const storedAuth = retrieveAuthData();

        const token = accessToken !== undefined && accessToken !== null 
            ? accessToken 
            : storedAuth?.accessToken;
            
        const customerEmail = email !== undefined && email !== null
            ? email
            : storedAuth?.email;

        if (token !== undefined && token !== null) {
            const fullCustomerData = {
                ...storedAuth,
                accessToken: token,
                email: customerEmail,
            };
            setCustomerData(fullCustomerData);
            setIsAuthenticated(true);
            if (customerEmail) {
                storeAuthData(fullCustomerData);
            }
        } else {
            setCustomerData(null);
            setIsAuthenticated(false);
        }
        setIsValidating(false);
    };

    validateToken();
}, [accessToken, email]);

    const login = (data) => {
        const token = data.token || data.accessToken;
        const newCustomerData = {...data, accessToken: token};
        setCustomerData(newCustomerData);
        setIsAuthenticated(true);
        storeAuthData(newCustomerData);
    };

    const logout = () => {
        setCustomerData(null);
        clearAuthData();
        setIsAuthenticated(false);
    };

    const updateCustomerData = (data) => {
        setCustomerData(prev => ({
            ...prev,
            ...data
        }));
    };

    const value = {
        customerData,
        isAuthenticated,
        isValidating,
        commerceClient,
        login,
        logout,
        updateCustomerData
    };

    
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}
